import * as THREE from 'three';
import { ConfiguratorModule } from '../types';

/*
 * Automobile configurator module.
 * Placeholder: a low-poly car silhouette.
 */
const automobile: ConfiguratorModule = {
  type: 'automobile',
  label: 'Automobile',
  // modelPath: '/models/automobile.glb',

  buildPlaceholder(): THREE.Object3D {
    const group = new THREE.Group();
    group.name = 'placeholder-automobile';

    const bodyMat = new THREE.MeshStandardMaterial({
      color: 0xef5350,
      roughness: 0.3,
      metalness: 0.65,
    });

    const darkMat = new THREE.MeshStandardMaterial({
      color: 0x1a1a2e,
      roughness: 0.9,
      metalness: 0.2,
    });

    const glassMat = new THREE.MeshStandardMaterial({
      color: 0x90caf9,
      roughness: 0.05,
      metalness: 0.1,
      transparent: true,
      opacity: 0.6,
    });

    // Lower body
    const lowerBody = new THREE.Mesh(
      new THREE.BoxGeometry(2.4, 0.55, 1.1),
      bodyMat
    );
    lowerBody.position.y = 0.42;
    lowerBody.castShadow = true;
    group.add(lowerBody);

    // Cabin / upper body
    const cabin = new THREE.Mesh(
      new THREE.BoxGeometry(1.5, 0.5, 0.95),
      bodyMat
    );
    cabin.position.y = 0.94;
    cabin.castShadow = true;
    group.add(cabin);

    // Windshield (front glass)
    const windshield = new THREE.Mesh(
      new THREE.PlaneGeometry(0.9, 0.42),
      glassMat
    );
    windshield.position.set(0.76, 0.96, 0);
    windshield.rotation.y = Math.PI / 2 - 0.4;
    group.add(windshield);

    // Four wheels
    const wheelGeo = new THREE.CylinderGeometry(0.3, 0.3, 0.22, 28);
    const wheelPositions: [number, number, number][] = [
      [-0.9, 0.3, 0.58],
      [0.9, 0.3, 0.58],
      [-0.9, 0.3, -0.58],
      [0.9, 0.3, -0.58],
    ];
    wheelPositions.forEach(([x, y, z]) => {
      const wheel = new THREE.Mesh(wheelGeo, darkMat);
      wheel.position.set(x, y, z);
      wheel.rotation.x = Math.PI / 2;
      wheel.castShadow = true;
      group.add(wheel);

      // Hub cap
      const hub = new THREE.Mesh(
        new THREE.CylinderGeometry(0.12, 0.12, 0.24, 16),
        new THREE.MeshStandardMaterial({ color: 0xbdbdbd, metalness: 0.9, roughness: 0.1 })
      );
      hub.position.set(x, y, z);
      hub.rotation.x = Math.PI / 2;
      group.add(hub);
    });

    return group;
  },
};

export default automobile;
